<template>
  <!--<div data-role="main"-->
  <!--class="ui-content"-->
  <!--style="min-height: 20px; margin-bottom: 50%"-->
  <!--&gt;-->
  <!--<br>-->
  <!--<div class="rangeslider" style="max-width: 90% !important;">-->
  <!--<input class="min"-->
  <!--name="range_1"-->
  <!--type="range"-->
  <!--:min="range_max_min? range_max_min: 0"-->
  <!--:max="range_max_max? range_max_max: 1000"-->
  <!--value="10"-->
  <!--:step="range_max_min? (range_max_max - range_max_min)/10: 100"-->
  <!--v-model="range.range_min"-->
  <!--style="max-width: 90% !important; margin: 2px;"-->
  <!--@change="changePriceData"-->
  <!--/>-->
  <!--<input class="max"-->
  <!--name="range_1"-->
  <!--type="range"-->
  <!--:min="range_max_min? range_max_min: 0"-->
  <!--:max="range_max_max? range_max_max: 1000"-->
  <!--:step="range_max_min? (range_max_max - range_max_min)/10: 100"-->
  <!--v-model="range.range_max"-->
  <!--style="max-width: 90% !important; margin: 2px;"-->
  <!--@change="changePriceData"-->
  <!--/>-->
  <!--<span class="range_min light left">-->
  <!--{{range.range_min | currencyConversion}}-->
  <!--</span>-->
  <!--<span class="range_max light right">-->
  <!--{{range.range_max | currencyConversion}}-->
  <!--</span>-->
  <!--</div>-->
  <!--</div>-->

  <!--<div class="price-slider">-->
    <!--<input class="min"-->
           <!--name="range_1"-->
           <!--type="range"-->
           <!--:min="range_max_min? range_max_min: 0"-->
           <!--:max="range_max_max? range_max_max: 1000"-->
           <!--:value="range.range_min"-->
           <!--:step="range_max_min? (range_max_max - range_max_min)/10: 100"-->
           <!--style="max-width: 90% !important; margin: 2px;"-->
           <!--@change="changePriceData"-->
           <!--@input="updatePriceLabels()"-->
    <!--/>-->
    <!--<input class="max"-->
           <!--name="range_1"-->
           <!--type="range"-->
           <!--:min="range_max_min? range_max_min: 0"-->
           <!--:max="range_max_max? range_max_max: 1000"-->
           <!--:step="range_max_min? (range_max_max - range_max_min)/10: 100"-->
           <!--:value="range.range_max"-->
           <!--style="max-width: 90% !important; margin: 2px;"-->
           <!--@change="changePriceData"-->
           <!--@input="updatePriceLabels()"-->
    <!--/>-->
    <!--<br>-->
    <!--<br>-->
    <!--<div style="display: inline-block">-->
      <!--<span style="white-space: nowrap; float: left;display: inline-block ">-->
        <!--{{range.range_min | currencyConversion}}-->
      <!--</span>-->
      <!--<span style="white-space: nowrap;display: inline-block">-->
        <!--{{range.range_max | currencyConversion}}-->
      <!--</span>-->
    <!--</div>-->

    <!--&lt;!&ndash;<input value="0" min="0" max="100" step="0.5" type="range" @input="updatePriceLabels()">&ndash;&gt;-->
    <!--&lt;!&ndash;<input value="100" min="0" max="100" step="0.5" type="range" @input="updatePriceLabels()"&ndash;&gt;-->
    <!--&lt;!&ndash;&gt;&ndash;&gt;-->
  <!--</div>-->
  <div class="range-slider">
    <!--<span class="rangeValues"></span>-->
    <div class="range-inputs">

    <input class="min"
           name="range_1"
           type="range"
           :min="range_max_min? range_max_min === range_max_max?0:range_max_min:0"
           :max="range_max_max? range_max_max: 1000"
           :value="range.range_min"
           :step="range_max_min?(range_max_max - range_max_min)/10: 100"
           @change="changePriceData"
           @input="updatePriceLabels()"
    />
    <input class="max"
           name="range_1"
           type="range"
           :min="range_max_min? range_max_min === range_max_max?0:range_max_min:0"
           :max="range_max_max? range_max_max: 1000"
           :step="range_max_min?(range_max_max - range_max_min)/10: 100"
           :value="range.range_max"
           @change="changePriceData"
           @input="updatePriceLabels()"

    />

    </div>
    <div class="range-indication">
      <span >
        {{range.range_min | currencyConversion}}
      </span>
      <span>
        {{range.range_max | currencyConversion}}
      </span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
	name: 'price-slider-filter',
	computed: {
		...mapGetters('filters', ['getFilterClassResponse'])
	},
	data () {
		return {
			range: {
				range_min: 0,
				range_max: 1000
			},
			previousRange: {
				range_min: 0,
				range_max: 1000
			},
			range_max_max: 1000,
			range_max_min: 0
		}
	},
	methods: {
		...mapActions('filters', ['updatePriceRange', 'setPriceFilterApplied']),
		changePriceData () {
			const sliders = document.querySelectorAll('.range-slider input')
			this.range = {
				range_min: parseInt(sliders[0].value),
				range_max: parseInt(sliders[1].value)
			}
			if (this.range.range_max !== this.range_max_max &&
          this.range.range_min !== this.range_max_min) {
				this.setPriceFilterApplied(true)
			} else {
				this.setPriceFilterApplied(false)
			}
			this.$emit('priceUpdate', {
				range_min: parseInt(sliders[0].value),
				range_max: parseInt(sliders[1].value)
			})
		},
		updatePriceLabels () {
			// avoids slider overlap
			const sliders = document.querySelectorAll('.range-slider input')
			const val1 = parseInt(sliders[0].value)
			const val2 = parseInt(sliders[1].value)
			if (val1 >= val2) {
				sliders[0].value = val2 - 3
				return
			}
			if (val2 <= val1) {
				sliders[1].value = val1 + 3
				return
			}

			// adds color when a range is selected
			if (val1 > 0 || val2 < 99) {
				sliders[0].style.background = sliders[1].style.background = '-webkit-gradient(linear, 0 0,100% 0, color-stop(0, white), color-stop(' + (val1 / 100) + ', white),color-stop(' + (val1 / 100) + ', #f0f0f0), color-stop(' + (val2 / 100) + ', #f0f0f0), color-stop(' + (val2 / 100) + ', white))'
			} else {
				sliders[0].style.background = sliders[1].style.background = ''
			}
		}
	},
	mounted () {
		this.$root.$on('clearAllFilter', () => {
			this.range.range_max = this.getFilterClassResponse.max_price
			this.range.range_min = this.getFilterClassResponse.min_price
			this.$emit('priceUpdate', this.range)
		})
		this.updatePriceLabels()
		this.updatePriceRange([parseInt(this.getFilterClassResponse.min_price, 10), parseInt(this.getFilterClassResponse.max_price, 10)])
		this.range_max_min = this.getFilterClassResponse.min_price
		this.range_max_max = this.getFilterClassResponse.max_price
		this.range.range_max = this.getFilterClassResponse.max_price
		this.range.range_min = this.getFilterClassResponse.min_price
		if (this.getFilterClassResponse.min_price === this.getFilterClassResponse.max_price) {
			this.range.range_min = 0
		}
	}
}
</script>

<style>
  div.range-slider {
    position: relative;
    width: 100%;
    height: 50px;
    float: left;
    text-align: center;
  }
  input[type="range"]::-webkit-slider-thumb {
    pointer-events: all;
    position: relative;
    z-index: 1;
    outline: 0;
    -webkit-appearance: none;
    width: 20px;
    height: 20px;
    border: none;
    border-radius: 14px;
    background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #dad8da), color-stop(100%, #413F41));
    /* android <= 2.2 */
    background-image: -webkit-linear-gradient(top, #dad8da 0, #413F41 100%);
    /* older mobile safari and android > 2.2 */
    background-image: linear-gradient(to bottom, #dad8da 0, #413F41 100%);
    /* W3C */
  }
  div.range-slider input[type="range"] {
    pointer-events: none;
    position: absolute;
    -webkit-appearance: none;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    border: none;
    border-radius: 14px;
    background: transparent!important;
    box-shadow: inset 0 1px 0 0 #cdc6c6, inset 0 -1px 0 0 #d9d4d4;
    -webkit-box-shadow: inset 0 1px 0 0 #cdc6c6, inset 0 -1px 0 0 #d9d4d4;
    left: 10px;
    top: 0;
    width: 90%;
    outline: none;
    height: 14px;
    margin: 0;
    padding: 0;
  }

  div.range-slider input[type="range"]::-webkit-slider-thumb {
    pointer-events: all;
    position: relative;
    z-index: 1;
    outline: 0;
    -webkit-appearance: none;
    width: 14px;
    height: 14px;
    border: 0;
    border-radius: 50%;
    background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #4174f0), color-stop(100%, #4174f0));
    /* android <= 2.2 */
    background-image: -webkit-linear-gradient(top, #4174f0 0, #4174f0 100%);
    /* older mobile safari and android > 2.2 */
    background-image: linear-gradient(to bottom, #4174f0 0, #4174f0 100%);
    /* W3C */
    box-shadow: 0 0 0 6px rgba(0,0,0,0.1);
    cursor:pointer;
  }
  div.range-slider input[type="range"]::-moz-range-thumb {
    pointer-events: all;
    position: relative;
    z-index: 10;
    -moz-appearance: none;
    width: 16px;
    height: 16px;
    border: none;
    border-radius: 14px;
    background-image: linear-gradient(to bottom, #4174f0 0, #4174f0 100%);
    /* W3C */
    box-shadow: 0 0 0 6px rgba(0,0,0,0.1);
    cursor:pointer;
  }
  div.range-slider input[type="range"]::-ms-thumb {
    pointer-events: all;
    position: relative;
    z-index: 10;
    -ms-appearance: none;
    width: 16px;
    height: 16px;
    border-radius: 14px;
    border: 0;
    background-image: linear-gradient(to bottom, #4174f0 0, #4174f0 100%);
    /* W3C */
    box-shadow: 0 0 0 6px rgba(0,0,0,0.1);
    cursor:pointer;
  }
  div.range-slider input[type=range]::-moz-range-track {
    position: relative;
    z-index: -1;
    background-color: white;
    border: 0;
  }
  div.range-slider input[type=range]:last-of-type::-moz-range-track {
    -moz-appearance: none;
    background: none transparent;
    border: 0;
  }
  div.range-slider input[type=range]::-moz-focus-outer {
    border: 0;
  }
   div.range-slider .range-indication{
     display: inline-flex;
     font-size: 11px;
     justify-content: space-between;
     width: 100%;
     padding: 0 10px;
   }
  div.range-slider .range-inputs{
    height: 25px;
    padding: 0 10px;
  }
</style>
